import { IconElements } from './icons';
import { GoalIndicationParameters } from '../contexts/investment-robot/GoalIndicationContext';

export const PathIcon = (iconId: GoalIndicationParameters['selectedGoal'], className?: string) => {
    if (!iconId) {
        return <IconElements.BarsUp className={className} />;
    }
    switch (iconId) {
        case 'house':
            return <IconElements.HouseOriginal className={className} />;
        case 'children':
            return <IconElements.FamilyThick className={className} />;
        case 'capital':
            return <IconElements.BarsUp className={className} />;
        case 'pension':
            return <IconElements.SchommelChair className={className} />;
        case 'travel':
            return <IconElements.Globe className={className} />;
    }
};

export const PathPageIcon = (pageId: string, className: string) => {
    if (!pageId) {
        return null;
    }

    const iconId = pageId.substring(pageId.indexOf('-') + 1);

    if (!iconId) {
        return null;
    }

    switch (iconId) {
        case 'capital-goal-amount':
            return pageId === 'house-capital-goal-amount' ? (
                <IconElements.HouseOriginal className={className} />
            ) : (
                <IconElements.Globe className={className} />
            );
        case 'initial-deposit':
            return <IconElements.MoneyBag className={className} />;
        case 'periodic-income':
            return <IconElements.MoneyPig className={className} />;
        case 'capital-goal-date':
            return <IconElements.Clock className={className} />;
        case 'periodic-deposit':
            return <IconElements.TimeAgenda className={className} />;
        case 'amount-children':
            return <IconElements.FamilyThick className={className} />;
        case 'amount-per-child':
            return <IconElements.FamilyThick className={className} />;
        case 'expert-level':
            return <IconElements.GrowingBars className={className} />;
        case 'risk-reduction':
            return <IconElements.GrowingBars className={className} />;
        case 'current-age':
            return <IconElements.SchommelChair className={className} />;
        case 'retirement-age':
            return <IconElements.SchommelChair className={className} />;
        case 'details':
            return <IconElements.Banner className={className} />;
    }

    return null;
};
